<div class="image-favorite" [style.width]="width">
    <!-- With dragHandle the header is the cdkDragHandle of the host's cdkDrag
         ancestor (e.g. a reorderable dashboard tile); otherwise it's inert. -->
    <ng-container *ngIf="!minimal">
        <div *ngIf="dragHandle" class="image-favorite-header drag-handle" cdkDragHandle>
            <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </div>
        <div *ngIf="!dragHandle" class="image-favorite-header">
            <ng-container *ngTemplateOutlet="headerContent"></ng-container>
        </div>
    </ng-container>
    <ng-template #headerContent>
        <h6 class="image-favorite-title" [title]="imageFavorite?.description ?? ''">{{ imageFavorite?.name }}</h6>
        <small *ngIf="isDynamicImage && image?.captureDate" class="text-muted">
            Captured {{ image.captureDate | date:'short' }}
        </small>
        <button *ngIf="labelsEditable" type="button" class="btn btn-sm"
                [class.btn-success]="!labelsEditMode" [class.btn-warning]="labelsEditMode"
                (click)="toggleLabelEditing()">
            {{ labelsEditMode ? 'Done Editing Labels' : 'Labels' }}
        </button>
        <i *ngIf="showEditButton" class="fas fa-pencil-alt image-favorite-edit" title="Edit image favorite"
           (click)="editRequested.emit(); $event.stopPropagation()"></i>
    </ng-template>

    <div #stage class="image-stage" [class.editing]="labelsEditMode" [class.no-image]="imageSrc == null">
        <img *ngIf="imageSrc != null" [src]="imageSrc" alt="{{ imageFavorite?.name }}" draggable="false" (load)="measureLabelsSoon()" />
        <div *ngIf="imageSrc == null" class="image-placeholder">
            <span>{{ imageLoading ? 'Loading image ...' : (isDynamicImage ? 'No recent gateway image' : 'No image uploaded') }}</span>
        </div>

        <!-- Leader lines (percent coordinates so arrowheads aren't distorted). -->
        <svg class="leader-lines">
            <defs>
                <marker *ngFor="let line of leaderLines; let i = index; trackBy: trackByIndex" [attr.id]="'ifArrow' + imageFavorite?.id + '_' + i"
                        viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                    <path d="M 0 0 L 10 5 L 0 10 z" [attr.fill]="line.color"></path>
                </marker>
            </defs>
            <line *ngFor="let line of leaderLines; let i = index; trackBy: trackByIndex"
                  [attr.x1]="line.x1 + '%'" [attr.y1]="line.y1 + '%'" [attr.x2]="line.x2 + '%'" [attr.y2]="line.y2 + '%'"
                  [attr.stroke]="line.color" stroke-width="2"
                  [attr.marker-end]="'url(#ifArrow' + imageFavorite?.id + '_' + i + ')'"></line>
        </svg>

        <ng-container *ngFor="let label of labels; trackBy: trackById">
            <div class="image-label"
                 [class.region]="label.labelType === LabelType.Region"
                 [class.plain]="label.labelType === LabelType.TextArrow && !propsOf(label).hasStickyBackground && !label.isDynamic"
                 [attr.data-label-id]="label.id"
                 [ngStyle]="labelStyle(label)"
                 (pointerdown)="startDrag($event, label, 'box')">
                <div *ngIf="label.text" class="label-text">{{ label.text }}</div>
                <div *ngIf="label.isDynamic" class="label-value" [ngStyle]="valueStyle(label)" [title]="valueTooltip(label)">
                    {{ formatValue(label) }}
                </div>
                <div *ngIf="labelsEditMode && label.labelType === LabelType.Region" class="resize-handle"
                     (pointerdown)="startDrag($event, label, 'resize')"></div>
            </div>

            <div *ngIf="labelsEditMode && showsTarget(label)" class="target-handle"
                 [style.left.%]="label.targetX" [style.top.%]="label.targetY"
                 (pointerdown)="startDrag($event, label, 'target')"></div>
        </ng-container>
    </div>
</div>
